type PaginationProps = {
  currentPage: number;
  totalPages: number;
  perPage: any;
  perPageOptions: number[];
  onPageChange: (page: number) => void;
  onPerPageChange: (count: any) => void;
  className?: string;
};
import { MdOutlineNavigateNext } from "react-icons/md";
import { LightText2 } from "../ui/Text";
import RadixSingleSelect from "../custom/RadixSingleSelect";

const Pagination = ({ currentPage, totalPages, perPage, perPageOptions, onPageChange, onPerPageChange, className }: PaginationProps) => {
  const getPagination = () => {
    const pages: (number | string)[] = [];

    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      pages.push(1);
      if (currentPage > 4) pages.push("...");
      const start = Math.max(2, currentPage - 1);
      const end = Math.min(totalPages - 1, currentPage + 1);
      for (let i = start; i <= end; i++) pages.push(i);
      if (currentPage < totalPages - 3) pages.push("...");
      pages.push(totalPages);
    }

    return pages;
  };

  return (
    <div className={`flex items-center justify-end md:px-4 py-2 bg-white ${className}`}>
      {/* Per Page Dropdown */}
      <div>
        <RadixSingleSelect
          options={perPageOptions.map((opt) => ({
            label: `Records per page ${opt}`,
            value: opt,
          }))}
          placeholder="Select"
          onChange={(option) => onPerPageChange(option)}
          selectedValue={perPage}
          className="w-full text-10 md:text-13 leading-normal font-normal text-text-primary gap-1"
          dropdownClassName="w-[150px] z-[60]"
          listClassName="max-h-[300px] overflow-y-auto text-text-default bg-white"
          activeClass="text-text-primary"
        />
      </div>

      {/* Pagination Controls */}
      <div className="flex items-center text-sm px-4">
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="px-3 py-1 text-text-default disabled:text-gray-400 disabled:cursor-not-allowed flex items-center"
        >
          <MdOutlineNavigateNext className={`rotate-180 size-4 ${currentPage === totalPages ? "text-gray-400" : "text-text-default"}`} />
          <LightText2 text="Prev" className={currentPage === 1 ? "text-gray-400" : "text-text-default"} />
        </button>

        {getPagination().map((page, idx) =>
          typeof page === "string" ? (
            <span key={idx} className="px-2 text-gray-500">
              ...
            </span>
          ) : (
            <button
              key={`${page}_${idx}`}
              onClick={() => onPageChange(page)}
              className={`px-3 py-1 rounded ${
                page === currentPage ? "bg-text-primary text-white border-text-primary" : "text-gray-600 border-gray-300 hover:bg-gray-100"
              }`}
            >
              {page}
            </button>
          )
        )}
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="px-3 py-1 text-text-default disabled:text-gray-400 disabled:cursor-not-allowed flex items-center"
        >
          <LightText2 text="Next" className={currentPage === totalPages ? "text-gray-400" : "text-text-default"} />
          <MdOutlineNavigateNext className={`size-4 ${currentPage === totalPages ? "text-gray-400" : "text-text-default"}`} />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
